<template>
  <div class="inline">
    <a-badge :count="count">
      <a-button type="dashed" icon="read" @click="show">查看试卷</a-button>
    </a-badge>

    <a-modal :footer="null" :visible="visible" :width="1000" title="试卷预览" @ok="handleCancel" @cancel="handleCancel">
      <a-form>
        <a-steps :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>
        <div class="steps-content">

          <div v-show="steps[current].keys == 1" style="padding: 20px;">
            <a-row type="flex" justify="center">
              <a-col span="20">
                <a-form-item>
                  <a-input v-model="exam.name" size="large" placeholder="试卷名称" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="16" type="flex" justify="center">
              <a-col span="3">
                <a-form-item>
                  <a-tree-select treeNodeFilterProp="title" showSearch v-model="exam.grade_id" style="width: 100%"
                    :treeData="gradeList" :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }"
                    placeholder="选择年级" @change="selectGradeItem" tree-default-expand-all allowClear></a-tree-select>
                </a-form-item>
              </a-col>
              <a-col span="3">
                <a-form-item>
                  <a-tree-select v-model="exam.semester_id" style="width: 100%" :treeData="semesterList"
                    :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }" placeholder="选择学期"
                    @change="selectSemesterItem" tree-default-expand-all allowClear></a-tree-select>
                </a-form-item>
              </a-col>
              <a-col span="3">
                <a-form-item>
                  <a-tree-select treeNodeFilterProp="title" showSearch v-model="exam.type" style="width: 100%"
                    :treeData="typelist" :replaceFields="{ children: 'children', title: 'name', key: 'name', value: 'id' }"
                    placeholder="选择试卷分类" @change="selectItem" allowClear></a-tree-select>
                </a-form-item>
              </a-col>
              <a-col span="3">
                <a-form-item>
                  <a-select v-model="exam.subject" placeholder="学科">
                    <a-select-option :key="1" :value="1">数学</a-select-option>
                    <a-select-option :key="2" :value="2">英语</a-select-option>
                    <a-select-option :key="3" :value="3">语文</a-select-option>
                    <a-select-option :key="4" :value="4">化学</a-select-option>
                    <a-select-option :key="5" :value="5">物理</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col span="3">
                <a-form-item>
                  <a-select v-model="exam.is_newtest" placeholder="是否新生测试">
                    <a-select-option :key="0" :value="0">不是新生</a-select-option>
                    <a-select-option :key="1" :value="1">是新生</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col span="3">
                <a-form-item>
                  <a-select v-model="exam.banben" placeholder="试卷版本">
                    <a-select-option :key="1" :value="1">人教版</a-select-option>
                    <a-select-option :key="2" :value="2">北师大版</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col span="3">

                <a-form-item>
                  <a-select v-model="exam.teacher_check_flag" placeholder="交叉批改">
                    <a-select-option :key="0" :value="0">不交叉批改</a-select-option>
                    <a-select-option :key="1" :value="1">交叉批改</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </div>

        <!-- <div v-show=" steps[current].keys==2" style="padding: 20px;">
                    <a-row :gutter="16" type="flex" justify="center">
                        <a-col :span="20">
                            <a-form-item>
                                <a-input v-model="exam.mission_name" size="large" placeholder="任务名称"
                                         style="width: 100%"/>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" type="flex" justify="center">
                        <a-col :span="8">
                            <a-form-item>
                                <a-tree-select treeNodeFilterProp="title" showSearch v-model="exam.mission_type"
                                               style="width: 100%" :treeData="missionTypeList"
                                               :replaceFields="{children:'children',title:'name',key:'name',value:'id'}"
                                               placeholder="任务类型" @change="selectMissionTypeItem"
                                               allowClear></a-tree-select>
                            </a-form-item>
                        </a-col>
                    </a-row>


                </div>
                <div v-show=" steps[current].keys==3" style="padding: 20px;">
                    <a-row :gutter="16" type="flex" justify="center">
                        <a-col :span="8">
                            <a-form-item>

                                <a-select v-model="exam.choose_org_id" placeholder="机构" size="large" allowClear>
                                    <a-select-option v-for="item in orglist" :key="item.id" :value="item.id">
                                        {{item.name}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" type="flex" justify="center">
                        <a-col :span="8">
                            <a-form-item>
                                <a-tree-select treeNodeFilterProp="title" size="large" showSearch
                                               v-model="exam.squad_id" style="width: 100%" :treeData="squadList"
                                               :replaceFields="{children:'children',title:'name',key:'id',value:'id'}"
                                               placeholder="选择班级" @change="selectSquadItem"
                                               tree-checkable allowClear></a-tree-select>
                            </a-form-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="16" type="flex" justify="center">
                        <a-col :span="10">
                            <a-form-item>
                                <a-range-picker :show-time="{ format: 'HH:mm' }" size="large"
                                                format="YYYY-MM-DD HH:mm:ss" :placeholder="['开始时间', '结束时间']"
                                                @change="changeTimeRange" @ok="changeTimeRange"/>
                            </a-form-item>
                        </a-col>
                    </a-row> 

                </div>-->


        <!-- <a-row class="task" :gutter="[16, 16]">
                    <a-col :span="24">
                        <a-checkbox v-model="showTaskOption">添加任务</a-checkbox>
                    </a-col>
                    <template v-if="showTaskOption">


                    </template>
                </a-row> -->

        <div style="position: absolute;right: 20px;">
          <!-- <a-button v-if="current > 0" style="margin-right: 8px" @click="current--">
                        上一步
                    </a-button>
                    <a-button v-if="current < steps.length - 1" type="primary" @click="current++">
                        下一步
                    </a-button> -->
          <!-- <a-button :loading="loading" style="width: 156px;" v-if="current == steps.length - 1" type="primary" @click="handleOk"> -->
          <a-button :loading="loading" style="width: 156px;" type="primary" @click="handleOk">
            提交
          </a-button>


        </div>

      </a-form>

      <div style="padding-top: 20px;">
        <a-divider></a-divider>
      </div>
      <a-list item-layout="vertical" :data-source="exam.questions">
        <a-list-item slot="renderItem" key="item.title" slot-scope="item">
          <a-list-item-meta>
            <div slot="title">
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'ANSWER'">问答题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'PREVIEW'">预习题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'VOICE'">语音题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'JUDGMENT'">判断题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'COMPLETION'">填空题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'VIDEO'">口述题
              </a-tag>
              <a-tag color="#87d068" style="float: left; margin-right: .5rem" v-if="item.typestr == 'SINGLE_CHOICE'">单选题
              </a-tag>
              <div v-html="item.title" />
            </div>
            <template slot="description">
              <a-row :gutter="16" v-if="item.typestr == 'SINGLE_CHOICE'">
                <a-col :span="6" v-for="option in item.options" :key="option.value">
                  <div class="option">
                    <label class="label">{{ option.keys }}:</label>
                    <div class="span" v-html="option.value" />
                  </div>
                </a-col>
              </a-row>
              <div>
                <span v-if="item.typestr == 'ANSWER' || item.typestr == 'VIDEO'">参考答案:</span>
                <span
                  v-if="item.typestr == 'JUDGMENT' || item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">答案:</span>
                <span v-if="item.typestr == 'COMPLETION' || item.typestr == 'SINGLE_CHOICE'">{{ item.answer }}</span>
                <span v-if="item.typestr == 'JUDGMENT' && item.answer == 1">正确</span>
                <span v-if="item.typestr == 'JUDGMENT' && item.answer == 0">错误</span>
              </div>
            </template>
          </a-list-item-meta>
          <a-row type="flex" justify="space-between">
            <div>
              <a-rate :value="item.star"></a-rate>
              <a-divider type="vertical" v-if="item.tag.length > 0"></a-divider>
              <a-tag v-for="tag in item.tag" :key="tag" color="#2db7f5">{{ tag }}</a-tag>
              <a-divider type="vertical"></a-divider>
              <template v-if="item.systag != 0">
                <a-tag color="#2db7f5">相似题</a-tag>
                <a-divider type="vertical" />
              </template>
              <a-button size="small" type="danger" icon="youtube">解析视频</a-button>
            </div>
            <div style="display: flex;">
              <span>
                <label>顺序：</label>
                <a-input :defaultValue="0" v-model="item.weigh" size="small" style="width: 4rem; margin-right: .5rem;"
                  placeholder="顺序" @blur="changeWeigh" />
              </span>
              <span>
                <label>分数：</label>
                <a-input :defaultValue="0" v-model="item.score" size="small" style="width: 4rem; margin-right: .5rem;"
                  placeholder="分值" />
              </span>
              <a-button size="small" type="danger" @click="handleRemoveQuestion(item)" ghost>移出试卷
              </a-button>
            </div>
          </a-row>
        </a-list-item>
      </a-list>


    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
    },
    editVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current: 0,
      steps: [
        {
          title: '试卷信息',
          keys: '1',
        },
        /* {
           title: '任务设置',
           keys: '2',
         },
         {
           title: '时间设置',
           keys: '3',
         }, */
      ],
      orglist: [],
      missionTypeList: [],
      squadList: [],
      visible: false,
      exam: {
        id: undefined,
        type: undefined,
        name: "",
        mission_name: "",
        mission_type: undefined,
        start_time: "",
        end_time: "",
        grade_id: undefined,
        choose_org_id: undefined,
        semester_id: undefined,
        squad_id: undefined,
        teacher_check_flag: 0,
        subject: 1,
        is_newtest: 0,
        banben: 1

      },
      typelist: [],
      loading: false,
      gradeList: [],
      semesterList: [],
      showTaskOption: false,
      answerList: ['']
    };

  },
  mounted() {
    this.exam = this.value;
    this.$axios
      .post("/api/QuestionTestpaperType/index")
      .then((res) => {
        if (res.code != 200) {
          this.$error({
            title: "错误",
            content: res.msg,
            okText: "确定",
          });
        } else {
          this.typelist = res.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });

    this.$axios
      .post("/api/BasicGrade/index", {
        pageinfo: {
          pageSize: 100
        }
      })
      .then((res) => {
        if (res.code != 200) {
          this.$error({
            title: "错误",
            content: res.msg,
            okText: "确定",
          });
        } else {
          this.gradeList = res.data.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });
    this.$axios
      .post("/api/BasicSemester/index", {
        pageinfo: {
          pageSize: 100
        }
      })
      .then((res) => {
        if (res.code != 200) {
          this.$error({
            title: "错误",
            content: res.msg,
            okText: "确定",
          });
        } else {
          this.semesterList = res.data.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });
    this.getOrgSquadlist();
    this.getMissionTypeList();
    this.getOrglist();
  },
  methods: {
    changeWeigh() {
      this.exam.questions = this.exam.questions.sort(function (res1, res2) {
        return parseInt(res1.weigh) < parseInt(res2.weigh) ? -1 : 1;
      });
    },
    changeTimeRange(val) {
      this.exam.start_time = parseInt(val[0].valueOf() / 1000);
      this.exam.end_time = parseInt(val[1].valueOf() / 1000);
    },
    getMissionTypeList() {
      this.$axios
        .post("/api/BasicMissionType/index")
        .then(res => {
          if (res.code == 200) {
            this.missionTypeList = res.data.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getOrgSquadlist() {
      // .post("/api/Admin/getorgsquadlist")
      this.$axios
        .post("/api/Admin/getorggradesquadlist")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.squadList = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getOrglist() {
      this.$axios
        .post("/api/Admin/getorgsquadlist")
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.orglist = res.data.org_list;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    selectItem(id) {
      this.exam.type = id;
    },
    selectGradeItem(id) {
      this.exam.grade_id = id;
    },
    selectSquadItem(id) {
      this.exam.squad_id = id;
    },
    selectMissionTypeItem(id) {
      this.exam.mission_type = id;
    },
    selectSemesterItem(id) {
      this.exam.semester_id = id;
    },

    show() {
      this.visible = true;
    },
    handleOk() {
      let data = JSON.parse(JSON.stringify(this.exam));
      if (data.name == "") {
        this.$error({
          title: "错误",
          content: "请填写试卷名字",
          okText: "确定",
        });
        return false;
      }
      if (data.type == "") {
        this.$error({
          title: "错误",
          content: "请选择试卷类型",
          okText: "确定",
        });
        return false;
      }
      if (data.questions.length < 1) {
        this.$error({
          title: "错误",
          content: "试卷必须包含最少一个题目",
          okText: "确定",
        });
        return false;
      }
      //需要直接添加任务
      if (this.showTaskOption) {
        if (!data.squad_id && !data.choose_org_id) {
          this.$error({
            title: "错误",
            content: "机构和班级至少需要选择一个",
            okText: "确定",
          });
          return false;
        }
        if (!data.mission_name || data.mission_name == "") {
          this.$error({
            title: "错误",
            content: "请输入任务名字",
            okText: "确定",
          });
          return false;
        }
        if (!data.mission_type) {
          this.$error({
            title: "错误",
            content: "请选择任务类型",
            okText: "确定",
          });
          return false;
        }
      }
      data.questions = [];
      for (let i = 0; i < this.exam.questions.length; i++) {
        if (!this.exam.questions[i]["score"]) {
          this.$error({
            title: "错误",
            content: "请填写第" + (i + 1) + "题的分数.",
            okText: "确定",
          });
          return false;
        }
        data.questions.push({
          id: this.exam.questions[i]["id"],
          score: this.exam.questions[i]["score"],
          weigh: this.exam.questions[i]["weigh"],
        });
      }

      let url = "/api/QuestionTestpaper/edit";
      if (!this.exam.id) {
        url = "/api/QuestionTestpaper/add";
      }
      this.loading = true;
      this.$axios
        .post(url, {
          data
        })
        .then((res) => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            this.$success({
              title: "编辑试卷",
              content: "编辑试卷成功",
              okText: "确定",
            });
            this.$emit("save");
            this.visible = false;
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;

        })
    },
    handleCancel() {
      console.log("cancel");
      this.visible = false;
    },
    handleRemoveQuestion(item) {
      this.$emit("remove", item);
    },
  },
  watch: {
    exam(val) {
      this.$emit("input", val);
    },
    editVisible(val) {
      this.visible = val;
    },
    value(val) {
      this.exam = val;
    },
  },
  computed: {
    count() {
      return this.exam.questions ? this.exam.questions.length : 0;
    },
  },
};
</script>

<style lang="less" scoped>
.task {
  background-color: #f8f8f8;
}

.inline {
  display: inline;
  margin-right: 1rem;
}

.option {
  display: flex;

  .label {
    font-weight: bold;
  }

  .span {
    width: 0;
    flex: 1;
    margin-left: 0.5rem;
  }
}
</style>
